// eslint-disable-next-line import/prefer-default-export
export const ANIMATION_STATES = {
  NONE: 0,
  SCROLL: 1,
  FINISHED: 2,
}
